module.exports = __webpack_public_path__ + "static/news_people.ad0d7a28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/data/screenshots/macau/news_people.jpg
// module id = ./src/app/data/screenshots/macau/news_people.jpg
// module chunks = 7